import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { Logger } from "@/lib/app-log.js";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

let messaging;

try {
  if (typeof window !== "undefined") {
    messaging = getMessaging(firebaseApp);
  }
} catch (error) {
  Logger.warn("Firebase Messaging initialization failed:", { error: error?.message });
  messaging = null;
}

export { messaging };
